import {
  CreateCompensationsRolloutByFixDocument,
  CreateCompensationsRolloutByFixMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCompensationsRolloutByFix = () => {
  const [createCompensationsRollout, { loading }] = useMutation(
    CreateCompensationsRolloutByFixDocument,
    {
      extractorFn: (data) => data.contractsMutations.createByFixContractsCompensationsRollout,
    }
  )

  return {
    loading,
    createCompensationsRolloutByFix(variables: CreateCompensationsRolloutByFixMutationVariables) {
      return createCompensationsRollout({
        variables,
      })
    },
  }
}
